import React from 'react'
import CheckActiveFilledSVG from "../../../assets/icons/check-active-filled.svg"
export const CheckActiveFilled: React.FC = () => {
  return (
    <img src={CheckActiveFilledSVG} alt="" className="w-[25px] h-[25px]" />
  )
}
